export default __webpack_public_path__ + "static/media/mediawiki-negative.a7f4c765.svg";